import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import GradientSurface from '../shared/GradientSurface';
import CityFilterChips from '../CityFilterChips';

/**
 * CityFilterSection
 * Section wrapper for the city filter: heading + GradientSurface container
 * with edge-fade overscroll for the pill-track chips.
 *
 * Forwards all CityFilterChips props to the underlying component, always
 * using the pill-track variant.
 */
function CityFilterSection({
  detectedCity,
  nearbyCities,
  selectedCity,
  onCitySelect,
  isDetecting,
  showAllCitiesOption,
}) {
  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="700" mb={2} color="text.secondary">
        Filter by City
      </Typography>

      <GradientSurface
        variant="surface"
        radius="20px"
        elevation="xs"
        sx={{
          p: 2,
          overflowX: 'auto',
          // Edge fades: mask left/right so overflowing pills fade out elegantly
          maskImage:
            'linear-gradient(to right, transparent 0px, black 12px, black calc(100% - 12px), transparent 100%)',
          WebkitMaskImage:
            'linear-gradient(to right, transparent 0px, black 12px, black calc(100% - 12px), transparent 100%)',
          '&::-webkit-scrollbar': { display: 'none' },
          scrollbarWidth: 'none',
        }}
      >
        <CityFilterChips
          variant="pill-track"
          detectedCity={detectedCity}
          nearbyCities={nearbyCities}
          selectedCity={selectedCity}
          onCitySelect={onCitySelect}
          isDetecting={isDetecting}
          showAllCitiesOption={showAllCitiesOption}
        />
      </GradientSurface>
    </Box>
  );
}

CityFilterSection.propTypes = {
  detectedCity: PropTypes.string,
  nearbyCities: PropTypes.arrayOf(PropTypes.string),
  selectedCity: PropTypes.string,
  onCitySelect: PropTypes.func.isRequired,
  isDetecting: PropTypes.bool,
  showAllCitiesOption: PropTypes.bool,
};

CityFilterSection.defaultProps = {
  detectedCity: null,
  nearbyCities: [],
  selectedCity: null,
  isDetecting: false,
  showAllCitiesOption: true,
};

export default CityFilterSection;
